import { captureAppError } from '@leagueplatform/observability';
import { SENTRY_CONSTANTS } from '@scfhp-web/shared-module/src/common/constants';
import { getAppInitDetails } from 'api/get-app-init-details';

export const getUserEligibility = async (isAuthenticated: boolean) => {
  try {
    const appInitDetails = await getAppInitDetails();

    return {
      eligible: appInitDetails?.eligibilityInfo?.reasonCode !== 1,
      details: appInitDetails.eligibilityInfo.reasonCodeDescription,
    };
  } catch (e: any) {
    captureAppError(new Error('Failed to fetch user eligibility'), {
      context: {
        Context: {
          authenticated: isAuthenticated,
          message: e?.message,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      tags: {
        authenticated: isAuthenticated,
      },
    });
    return { eligible: true, details: null, error: true };
  }
};
